module.exports = __webpack_public_path__ + "img/hydro_disable.f6e16fb6.svg";